import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import { PackageType } from '../../../types';

import store from '../../store';

type PackageSelectedInput = {
    packageType: PackageType;
    location: 'Cards' | 'Table header';
};

const { PACKAGE, LOCATION } = MIXPANEL_EVENT_PROPERTIES;

export const reportPackageSelected = ({
    packageType,
    location,
}: PackageSelectedInput): void => {
    mixpanel.track('Logo Maker - Packages Page - Package Selected', {
        [PACKAGE]: packageType,
        [LOCATION]: location,
        ...getDataFromStores(
            store.user,
            store.referrer,
            store.pagePath,
            store.userActivated,
            store.brief,
            store.variationId,
            store.projectId,
            store.sellerId,
            store.orderType,
            store.fromBoost
        ),
    });
};
